import 'svelte/internal/disclose-version';
import * as $ from 'svelte/internal/client';
import TopBar from '../components/layout/TopBar.svelte';
import Card from '../components/shared/Card.svelte';
import DiaperLog from '../components/health/DiaperLog.svelte';
import WeightEntry from '../components/health/WeightEntry.svelte';
import GrowthChart from '../components/health/GrowthChart.svelte';
import SessionCard from '../components/session/SessionCard.svelte';
import { getRecentDiapers, getWeightHistory } from '../lib/services/health';
import { getActiveChild } from '../lib/stores/children.svelte.ts';
import { formatTime } from '../lib/utils/time';

var root_2 = $.from_html(`<div class="diaper-item svelte-31hnsy67nv5wt"><span> </span> <span class="diaper-time svelte-31hnsy67nv5wt"> </span></div>`);
var root_1 = $.from_html(`<section class="svelte-31hnsy67nv5wt"><h3 class="svelte-31hnsy67nv5wt">Recent Diapers</h3> <div class="diaper-list svelte-31hnsy67nv5wt"></div></section>`);
var root = $.from_html(`<!> <div class="health-page svelte-31hnsy67nv5wt"><section class="svelte-31hnsy67nv5wt"><h3 class="svelte-31hnsy67nv5wt">Diaper Log</h3> <!></section> <!> <section class="svelte-31hnsy67nv5wt"><h3 class="svelte-31hnsy67nv5wt">Weight</h3> <!></section> <section class="svelte-31hnsy67nv5wt"><h3 class="svelte-31hnsy67nv5wt">Growth</h3> <!></section></div>`, 1);

function Health($$anchor, $$props) {
	$.push($$props, true);

	const activeChild = $.derived(getActiveChild);
	let recentDiapers = $.state($.proxy([]));
	let weights = $.state($.proxy([]));

	$.user_effect(() => {
		if (!$.get(activeChild)) return;

		loadData();
	});

	async function loadData() {
		if (!$.get(activeChild)) return;

		$.set(recentDiapers, await getRecentDiapers($.get(activeChild).id, 10), true);
		$.set(weights, await getWeightHistory($.get(activeChild).id), true);
	}

	const typeLabels = { wet: '💧 Wet', dirty: '💩 Dirty', both: '💧💩 Both' };
	var fragment = root();
	var node = $.first_child(fragment);

	TopBar(node, { title: 'Baby Care', showBack: true, backPath: '/more' });

	var div = $.sibling(node, 2);
	var section = $.child(div);
	var node_1 = $.sibling($.child(section), 2);

	DiaperLog(node_1, { onlogged: loadData });
	$.reset(section);

	var node_2 = $.sibling(section, 2);

	{
		var consequent = ($$anchor) => {
			var section_1 = root_1();
			var div_1 = $.sibling($.child(section_1), 2);

			$.each(div_1, 21, () => $.get(recentDiapers), (diaper) => diaper.id, ($$anchor, diaper) => {
				var div_2 = root_2();
				var span = $.child(div_2);
				var text = $.child(span, true);

				$.reset(span);

				var span_1 = $.sibling(span, 2);
				var text_1 = $.child(span_1, true);

				$.reset(span_1);
				$.reset(div_2);

				$.template_effect(
					($0) => {
						$.set_text(text, typeLabels[$.get(diaper).type]);
						$.set_text(text_1, $0);
					},
					[() => formatTime($.get(diaper).time)]
				);

				$.append($$anchor, div_2);
			});

			$.reset(div_1);
			$.reset(section_1);
			$.append($$anchor, section_1);
		};

		$.if(node_2, ($$render) => {
			if ($.get(recentDiapers).length > 0) $$render(consequent);
		});
	}

	var section_2 = $.sibling(node_2, 2);
	var node_3 = $.sibling($.child(section_2), 2);

	WeightEntry(node_3, { onsaved: loadData });
	$.reset(section_2);

	var section_3 = $.sibling(section_2, 2);
	var node_4 = $.sibling($.child(section_3), 2);

	GrowthChart(node_4, {
		get weights() {
			return $.get(weights);
		}
	});

	$.reset(section_3);
	$.reset(div);
	$.append($$anchor, fragment);
	$.pop();
}

if (import.meta.hot) {
	Health = $.hmr(Health);

	import.meta.hot.accept((module) => {
		$.cleanup_styles('svelte-31hnsy67nv5wt');
		Health[$.HMR].update(module.default);
	});
}

export default Health;
import "bun-svelte:Health.svelte-2i1zzzzoa8tux-style.css";